import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import DevSandboxSkeleton from 'components/DevSandbox/DevSandboxSkeleton';
import { ERoute } from 'types/frontend';

/**
 * Fallback redirect for /prototypes/new.
 * Prototype creation now happens in NewPrototypeModal (with skip_generation).
 * This page only exists for backward compatibility — redirects to /prototypes.
 */
const NewPrototype = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(ERoute.Prototypes, { replace: true });
  }, [navigate]);

  return <DevSandboxSkeleton loadingText="Redirecting..." />;
};

export default NewPrototype;
